<template>
  <div id="shared-fields-participant-modal" class="modal fade" role="dialog" aria-hidden="true">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" class="close" data-dismiss="modal" aria-hidden="true"></button>
          <h4 class="modal-title">Select fields to share with {{ participantSingularName }}</h4>
        </div>
        <div class="modal-body">
          <div class="row">
            <div
              v-for="field in fieldsToShare"
              class="col-md-3"
              :key="field.name"
            >
              <label class="mt-checkbox mt-checkbox-outline" :id="'hide-' + field.name">
                {{ field.description }}
                <input :name="field.name"
                       type="checkbox"
                       :value="true"
                       v-model="field.by_participant"
                />
                <!-- XXX: this span is required for custom checkbox to display icon -->
                <span></span>
              </label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn green" @click.prevent="save" data-dismiss="modal">Save</button>
          <button class="btn default" data-dismiss="modal">Cancel</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { pick } from 'lodash';
import participantDisplayName from '@/mixins/participantDisplayName';

const FIELDS_TO_SHARE = ['address', 'checkbox', 'checkbox-group',  'currency', 'date', 'select', 'signature',
  'file', 'image-upload', 'textarea', 'number', 'radio-group', 'rating', 'text', 'time', 'phone', 'ssn'];

export default {
  props: {
    fieldList: {
      type: Array,
      required: true
    }
  },
  mixins: [
    participantDisplayName
  ],
  data() {
    return {
      fieldsToShare: [],
    }
  },
  mounted: function() {
    $('#shared-fields-participant-modal').on('show.bs.modal', () => {
      // filter fields that can be shared and copy only required properties to avoid mutating parent prop
      this.fieldsToShare = this.fieldList
        .filter(f => FIELDS_TO_SHARE.includes(f.type))
        .map(f => pick(f, ['name', 'description', 'by_participant']))
    });
  },
  methods: {
    save() {
      this.$emit('share', this.fieldsToShare);
    },
  }
}
</script>


<style scoped lang="scss">
.share-field-label {
  margin-bottom: 10px;
}
</style>



// WEBPACK FOOTER //
// ShareFieldsWithParticipantModal.vue?abb035e4